'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import formatEmailSubscriptions from './formatEmailSubscriptions';
import get from 'transmute/get';
const formatEmailSubscriptionGroupRecord = group => {
  return new ReferenceRecord({
    id: `${group.preferencesGroup.id}`,
    label: group.preferencesGroup.name,
    referencedObject: fromJS(Object.assign({}, group, {
      subscriptionTypes: formatEmailSubscriptions(group.translatedSubscriptionDefinitions.map(t => t.subscriptionDefinition))
    }))
  });
};
const filterGroupSubscriptionTypes = (group, isDefault) => {
  return Object.assign({}, group, {
    translatedSubscriptionDefinitions: group.translatedSubscriptionDefinitions.filter(({
      subscriptionDefinition: {
        defaultSubscription
      }
    }) => !!defaultSubscription === isDefault)
  });
};
const formatEmailSubscriptionGroups = response => {
  const {
    preferencesGroups,
    userAccessibleGroups
  } = response;
  const groups = userAccessibleGroups.reduce((arr, id) => {
    return [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    ...arr, preferencesGroups.find(g => g.preferencesGroup.id === id)];
  }, []);
  if (!groups.length) {
    return [];
  }
  const groupsWithDefaults = [Object.assign({}, filterGroupSubscriptionTypes(groups[0], true), {
    preferencesGroup: {
      id: 'DEFAULT',
      name: 'Default subscription types' // should be overridden
    }
  }), ...groups.map(g => filterGroupSubscriptionTypes(g, false))];
  return indexBy(get('id'), List(groupsWithDefaults).map(formatEmailSubscriptionGroupRecord));
};
export default formatEmailSubscriptionGroups;